import styles from './AppInfo.module.css';
import SlackLogo from '../../assets/images/slack.png';
import ZoomLogo from '../../assets/images/zoom.png';

interface IAppInfo {
  zoomLink: string;
}

const AppInfo = ({ zoomLink }: IAppInfo) => {
  return (
    <div className={styles.appInfoContainerDiv} data-testid={'appInfoDivTestId'}>
      <div className={styles.slackLogoDiv}>
        <a href={import.meta.env.VITE_APP_SLACK_LINK_URL} target="_blank" rel="noopener noreferrer">
          <img src={SlackLogo} className={styles.slackImgStyle} alt={'Slack logo'} />
          <span>live</span>
        </a>
      </div>
      {zoomLink && (
        <div className={styles.slackLogoDiv}>
          <a href={zoomLink} target="_blank" rel="noopener noreferrer">
            <img src={ZoomLogo} className={styles.zoomImgStyle} alt={'Zoom logo'} />
            <span>Zoom Call</span>
          </a>
        </div>
      )}
    </div>
  );
};

export default AppInfo;
